import * as React from 'react';
import s from './PriceQuoteLoader.scss';
import { Text, Loader, Heading } from '@wix/design-system';
import { withTranslation } from '@wix/fe-essentials/i18n';
const PriceQuoteLoader = ({ t }) => {
    return (React.createElement("div", { className: s.container },
        React.createElement("div", { className: s.loader },
            React.createElement(Loader, { size: "large" })),
        React.createElement("div", { className: s.heading },
            React.createElement(Heading, null, t('invoice-view:price_quote.loader.heading'))),
        React.createElement(Text, null, t('price_quote.loader.message'))));
};
export default withTranslation(['invoice-view', 'locale-data'])(PriceQuoteLoader);
//# sourceMappingURL=PriceQuoteLoader.js.map